import { useState } from "react";
import "./modal.css";
import { usePlayerAccount } from "../../APIContext/PlayerAccountContext";
import { Calendar } from "primereact/calendar";
import Swal from "sweetalert2";

const jerseySizes = [
  { label: "Small", value: "S" },
  { label: "Medium", value: "M" },
  { label: "Large", value: "L" },
  { label: "Extra Large", value: "XL" },
  { label: "Youth Small", value: "YS" },
  { label: "Youth Medium", value: "YM" },
  { label: "Youth Large", value: "YL" },
];

const gradeList = [
  { label: "2nd", value: "2nd" },
  { label: "3rd", value: "3rd" },
  { label: "4th", value: "4th" },
  { label: "5th", value: "5th" },
  { label: "6th", value: "6th" },
  { label: "7th", value: "7th" },
  { label: "8th", value: "8th" },
  { label: "High School", value: "High School" },
  { label: "College", value: "College" },
  { label: "Professional", value: "Professional" },
];

const genderList = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" },
];

const AddPlayerProfileModal = ({ onClose, fetchPlayers: getPlayers }) => {
  const { createPlayer, fetchPlayers } = usePlayerAccount();

  const [formData, setFormData] = useState({
    name: "",
    date_of_birth: "",
    age: "",
    grade: "",
    gender: "",
    jersey_size: "",
    school_name: "",
    profile_picture: null,
  });

  const handleDateChange = (e) => {
    const dob = e.value;
    if (!dob) return;

    const today = new Date();
    const age =
      today.getFullYear() -
      dob.getFullYear() -
      (today.getMonth() < dob.getMonth() ||
      (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())
        ? 1
        : 0);

    const year = dob.getFullYear();
    const month = String(dob.getMonth() + 1).padStart(2, "0");
    const day = String(dob.getDate()).padStart(2, "0");

    const formattedDOB = `${year}-${month}-${day}`;

    setFormData((prev) => ({
      ...prev,
      date_of_birth: formattedDOB,
      age: age.toString(),
    }));
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      profile_picture: e.target.files[0],
    });
  };

  const handleSubmit = async () => {
    if (
      !formData.name ||
      !formData.date_of_birth ||
      !formData.age ||
      !formData.grade ||
      !formData.gender
    ) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Need all details to save",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      onClose();
      return;
    }
    const fd = new FormData();
    fd.append("name", formData.name);
    fd.append("date_of_birth", formData.date_of_birth);
    fd.append("age", formData.age);
    fd.append("grade", formData.grade);
    fd.append("gender", formData.gender);
    fd.append("jersey_size", formData.jersey_size);
    fd.append("school_name", formData.school_name);

    if (formData.profile_picture instanceof File) {
      fd.append("profile_picture", formData.profile_picture);
    }

    await createPlayer(fd);

    if (getPlayers) {
      await fetchPlayers();
    }

    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-box bg-custom brightness"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3 className="text-clip">Add Player Profile Details</h3>
        </div>

        <div className="modal-content">
          <div className="modal-row profile-pic-row">
            <label className="text-clip">Profile Picture</label>

            <div
              className="profile-pic-wrapper"
              onClick={() => document.getElementById("profilePicInput").click()}
            >
              {formData.profile_picture ? (
                <img
                  src={URL.createObjectURL(formData.profile_picture)}
                  alt="preview"
                  className="profile-pic-preview"
                />
              ) : (
                <div className="camera-icon">📷</div>
              )}
            </div>

            <input
              type="file"
              id="profilePicInput"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </div>

          <div className="modal-row">
            <label className="text-clip">Name</label>
            <input name="name" value={formData.name} onChange={handleChange} />
          </div>

          <div className="modal-row">
            <label className="text-clip">Date of Birth (MM-DD-YYYY)</label>
            <Calendar
              placeholder="Date of Birth"
              value={
                formData.date_of_birth ? new Date(formData.date_of_birth) : null
              }
              onChange={handleDateChange}
              showIcon
              required
              dateFormat="mm-dd-yy"
              className="calesndr-cstm"
              maxDate={new Date()}
            />
          </div>

          <div className="modal-row">
            <label className="text-clip">Age</label>
            <input
              name="age"
              type="number"
              required
              value={formData.age}
              onChange={handleChange}
            />
          </div>

          <div className="modal-row">
            <label className="text-clip">Gender</label>
            <select
              name="gender"
              required
              value={formData.gender}
              onChange={handleChange}
              className="select-input"
            >
              <option value="">Select Gender</option>
              {genderList.map((grade) => (
                <option key={grade.value} value={grade.value}>
                  {grade.label}
                </option>
              ))}
            </select>
          </div>

          <div className="modal-row">
            <label className="text-clip">Grade</label>
            <select
              name="grade"
              value={formData.grade}
              onChange={handleChange}
              required
              className="select-input"
            >
              <option value="">Select Grade</option>
              {gradeList.map((grade) => (
                <option key={grade.value} value={grade.value}>
                  {grade.label}
                </option>
              ))}
            </select>
          </div>

          <div className="modal-row">
            <label className="text-clip">Jersey Size</label>
            <select
              name="jersey_size"
              value={formData.jersey_size}
              onChange={handleChange}
              required
              className="select-input"
            >
              <option value="">Select Jersey Size</option>
              {jerseySizes.map((size) => (
                <option key={size.value} value={size.value}>
                  {size.label}
                </option>
              ))}
            </select>
          </div>

          <div className="modal-row">
            <label className="text-clip">School Name</label>
            <input
              name="school_name"
              required
              value={formData.school_name}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="modal-actions">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="save-btn" onClick={handleSubmit}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPlayerProfileModal;
